import styled from 'styled-components';

export const HomeContainer = styled.div`
  > p {
    text-align: center;
    margin: 8px 0;
  }
`;
